import type { TCustomerType } from '@team-milva/lab-models/customer'
import type { TOrderSegment } from '@team-milva/lab-models/resources'

export interface ICreateOrderCustomerForm {
  customerType: TCustomerType
  segment: TOrderSegment
  isInsuranceCase: boolean
  insurancePartnerID: string
  insuranceNumber: string
  customerAccountID: string
  insuranceCustomerAccountID: string
  customerUserID: string
  privateUserID: string
}

export interface ICreateOrderCustomerFields {
  segment: TOrderSegment
  isInsuranceCase: boolean
  insurancePartnerID: string | null
  insuranceNumber: string | null
  customerAccountID: string
  insuranceCustomerAccountID?: string
  customerUserID: string
  privateUserID: string
}

/**
 * The customer half of the createOrder body, from `CreateOrderModal`'s form.
 *
 * An insurance customer ordering on its own behalf (MIL-402) is a `'business'` segment order
 * with no customer account, owned by the insurance customer, and always its own insurance case:
 * the insurer is the insurance customer itself. lab-cloud forces the same values and rejects
 * conflicting ones, so they are sent exactly as the server will store them. The insurance
 * number stays optional.
 */
export function buildCreateOrderCustomerFields(
  form: ICreateOrderCustomerForm
): ICreateOrderCustomerFields {
  if (form.customerType === 'insurance') {
    return {
      segment: 'business',
      isInsuranceCase: true,
      insurancePartnerID: form.insuranceCustomerAccountID,
      insuranceNumber: form.insuranceNumber || null,
      customerAccountID: '',
      insuranceCustomerAccountID: form.insuranceCustomerAccountID,
      customerUserID: form.customerUserID,
      privateUserID: '',
    }
  }
  return {
    segment: form.segment,
    isInsuranceCase: form.isInsuranceCase,
    insurancePartnerID: form.insurancePartnerID || null,
    insuranceNumber: form.insuranceNumber || null,
    customerAccountID: form.customerAccountID,
    customerUserID: form.customerUserID,
    privateUserID: form.privateUserID,
  }
}
